import React from 'react';
import styled from 'styled-components';
import { COLORS, FONT_SIZE, FONT_WEIGHT } from 'styles/variables';

interface IDisplayText {
  label?: string | number;
  fontSize?: keyof typeof FONT_SIZE;
  fontWeight?: keyof typeof FONT_WEIGHT;
  color?: keyof typeof COLORS;
  children?: React.ReactNode;
  className?: string;
  colorExternal?: string;
  textAlign?: 'center' | 'start' | 'end' | 'left' | 'justify' | 'match-parent';
  fontStyle?: 'italic' | 'normal' | 'oblique';
  lineHeight?: number | string;
  as?: React.ElementType;
  margin?: string;

  [key: string]: any;
}

type DisplayTextType = Required<
  Pick<
    IDisplayText,
    | 'fontSize'
    | 'fontWeight'
    | 'color'
    | 'margin'
    | 'textAlign'
    | 'fontStyle'
    | 'lineHeight'
  >
> &
  Pick<IDisplayText, 'colorExternal'>;

const Text = styled.p<DisplayTextType>`
  font-size: ${(props) => FONT_SIZE[props.fontSize]};
  font-weight: ${(props) => FONT_WEIGHT[props.fontWeight]};
  color: ${(props) =>
    props.colorExternal ? props.colorExternal : COLORS[props.color]};
  margin: ${({ margin }) => margin};
  text-align: ${({ textAlign }) => textAlign};
  font-style: ${({ fontStyle }) => fontStyle};
  line-height: ${({ lineHeight }) => lineHeight};
`;

function DisplayText({
  label,
  fontSize = 'S',
  fontWeight = 'REGULAR',
  color = 'BLACK_2',
  children,
  className,
  as,
  colorExternal,
  margin,
  textAlign,
  fontStyle = 'normal',
  lineHeight = 'normal',
  ...props
}: IDisplayText) {
  return (
    <Text
      fontSize={fontSize}
      fontWeight={fontWeight}
      color={color}
      colorExternal={colorExternal}
      className={className}
      margin={margin}
      as={as}
      textAlign={textAlign}
      fontStyle={fontStyle}
      lineHeight={lineHeight}
      {...props}>
      {label}
      {children}
    </Text>
  );
}

export default DisplayText;
